import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isFoxSoulResetPasswordPage } from 'helpers/RouteHelper';
import { FoxSoul } from 'images';
import Network from '../Network';
import Style from './ResetPasswordSuccess.module.scss';

const ResetPasswordSuccess = ({ language, network, onClose }) => {
  const {
    profileResetPw_successButton: successButtonText,
    profileResetPw_successHeader: headerText,
    profileResetPw_successMessage: messageText,
  } = language || {};
  return (
    <main
      className={classNames(
        Style.resetPasswordSuccess,
        isFoxSoulResetPasswordPage && Style.isFoxSoul,
      )}
    >
      <div className={Style.resetPasswordSuccessWrap}>
        <div className={Style.signupSuccessContainer}>
          <div className={Style.secondaryHeader}>
            {isFoxSoulResetPasswordPage ? (
              <FoxSoul className={Style.logo} alt="Fox Soul" />
            ) : (
              <Network network={network} />
            )}
          </div>
          <div className={Style.resetPasswordSuccessHeaderText}>{headerText}</div>
          <div className={Style.resetPasswordSuccessText}>{messageText}</div>
        </div>
        <div className={Style.resetPasswordSuccessButton}>
          <button onClick={onClose} className={Style.btnPrimary}>
            {successButtonText}
          </button>
        </div>
      </div>
    </main>
  );
};

ResetPasswordSuccess.defaultProps = {
  language: {},
  network: [],
  onClose: () => {},
};

ResetPasswordSuccess.propTypes = {
  language: PropTypes.shape({
    profileResetPw_successButton: PropTypes.string,
    profileResetPw_successHeader: PropTypes.string,
    profileResetPw_successMessage: PropTypes.string,
  }),
  network: PropTypes.arrayOf(PropTypes.shape({})),
  onClose: PropTypes.func,
};

export default ResetPasswordSuccess;
